import {Injectable} from "@angular/core";
import {environment} from "src/environments/environment";
import {HttpClient} from "@angular/common/http";
import {AdventCalendarGameData} from "@models/game-data/AdventCalendarGameData";
import {map} from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class AdventCalendarService {
    apiPrefix = environment.serverlessApiBaseUrl + "/calendar-game";

    constructor(private http: HttpClient) { }

    createGameData(data: AdventCalendarGameData) {
        return this.http.post(this.apiPrefix + "/game-settings/", data)
            .pipe();
    }

    getGameData(campaignId: string) {
        return this.http.get<any>(`${this.apiPrefix}/game-settings/${campaignId}`).pipe(
            map((gameData) => gameData)
        );
    }

    updateGameData(campaignId: string, data: AdventCalendarGameData) {
        return this.http.put(this.apiPrefix + `/game-settings/${campaignId}`, data).pipe();
    }
}
